import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanLoad, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable()
export class AuthGuard implements CanActivate, CanLoad {

  constructor(private authService: AuthService, private router: Router) { }

  /**
   * Checks for user session and redirects to login if none.
   */
  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return new Promise((resolve) => {
      this.authService
        .hasValidSession()
        .then((value) => {
          if(!value) {
            resolve(false);
            this.router.navigate(['public/login']);
            return;
          }

          resolve(true);
        })
        .catch(() => {
          this.router.navigate(['public/login']);
          resolve(false);
        });
    });
  }

  /**
   * Handles whether the routing system can load the async module route
   */
  public canLoad(): Promise<boolean> {
    return new Promise((resolve) => {
      this.authService
        .hasValidSession()
        .then((value) => {
          if(!value) {
            resolve(false);
            this.router.navigate(['public/login']);
            return;
          }

          resolve(true);
        })
        .catch(() => {
          resolve(false);
          this.router.navigate(['public/login']);
        });
    });
  }
}
